// extracted by mini-css-extract-plugin
export default {"placeholder":"social-shelf-items-Photo__placeholder--kaAnP","icon":"social-shelf-items-Photo__icon--_gtcr"};